import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  MenuItem,
  Box,
  Autocomplete,
} from "@mui/material";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import { motion } from "framer-motion";

import Swal from "sweetalert2";

import { styled } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import CardHeadMenu from "../CardHeadMenu/CardHeadMenu";
import configServ from "../../../services/config";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#1976d2", // MUI blue
  color: "#fff",
  fontWeight: "bold",
}));

const StyledEvenRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#f5f5f5", // light grey
}));

const AddInstructor = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const companyId = parseInt(queryParams.get("company_id"), 10);
  const itemId = parseInt(queryParams.get("id"), 10);
  const titlee = queryParams.get("title");
  const orderOptions = Array.from({ length: 20 }, (_, i) => i + 1);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false); // For update state
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    video_url: "",
    order_number: "",
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [customers, setCustomers] = useState([]);

  console.log("companyId:", companyId, "itemId:", itemId);

  // Handle popup (open/close form)
  const handlePopup = () => {
    try {
      if (isCreate === true) {
        clear();
      }
      setIsCreate(!isCreate);
    } catch (error) {
      console.log(error);
    }
  };

  // Clear form fields
  const clear = () => {
    setFormData({
      title: "",
      description: "",
      video_url: "",
      order_number: "",
    });
    setValidationErrors({});
    setIsEdit(false);
  };

  // Handle input changes
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Validate form fields
  const validate = () => {
    const errors = {};
    if (!formData.title?.trim()) errors.title = "title is required.";
    if (!formData.order_number) errors.order_number = "Order no. is required.";

    return errors;
  };

  // Submit form
  const handleSubmit = async () => {
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    try {
      const payload = {
        ...formData,
        company_id: companyId,
        course_id: itemId,
      };

      if (isEdit) {
        console.log("Updating FAQ:", payload);
        const res = await configServ.updateChapterById(formData.id, payload);
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Course chapter updated successfully.",
          });
          clear();
          setIsCreate(false);
          fetchfaqs();
        }
      } else {
        // Make create API call here
        console.log("Creating FAQ:", payload);
        const res = await configServ.addChapterToCourse(payload);
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "chapter created successfully.",
          });
          clear();
          setIsCreate(false);
          fetchfaqs();
        }
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const [faqs, setFaqs] = useState([]);
  const [loader, setLoader] = useState(true);

  const fetchfaqs = async () => {
    try {
      setLoader(true);
      const payload = {
        company_id: companyId,
        course_id: itemId,
      };

      const res = await configServ.getChaptersByCourseId(payload);
      if (res.success) {
        setFaqs(res.data);
      } else {
        setFaqs([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchfaqs();
  }, []);

  const handleEdit = (faq) => {
    console.log("faq", faq);
    setIsCreate(true);
    setFormData(faq);
    setIsEdit(true);
  };

  const fetchCustomerList = async () => {
    try {
      const result = await configServ.get_customer({
        company_id: companyId,
      });

      setCustomers(result);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (isCreate) {
      fetchCustomerList();
    }
  }, [isCreate]);

  const highlightMatch = (text, query) => {
    try {
      const words = query.toLowerCase().split(" ").filter(Boolean);
      const regex = new RegExp(`(${words.join("|")})`, "gi");

      return text.split(regex).map((part, index) =>
        words.includes(part.toLowerCase()) ? (
          <mark key={index} style={{ backgroundColor: "#ffe58f" }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      );
    } catch (e) {
      console.error("Error in highlightMatch:", e);
      return text;
    }
  };

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Add Insructor's"}
        handlePopup={handlePopup}
        create={isCreate}
      />

      {isCreate === true && (
        <Container>
          <Grid
            container
            alignItems="center"
            justifyContent="flex-start"
            spacing={1}
          >
            <Grid item xs={6} md={3}></Grid>
            <Grid
              container
              item
              xs={6}
              md={9}
              justifyContent={"flex-start"}
            ></Grid>
          </Grid>

          <motion.div
            style={{
              width: "100%",
              backgroundColor: "#e3f3fc",
              padding: 20,
              borderRadius: "10px",
              border: "none",
            }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1, delay: 0.1 }}
          >
            <Grid
              container
              alignItems="flex-end"
              justifyContent="flex-start"
              spacing={1}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    disablePortal
                    fullWidth
                    size="small"
                    id="customer_id"
                    name="customer_id"
                    options={customers}
                    getOptionLabel={(option) => option.fname}
                    filterOptions={(options, { inputValue }) => {
                      const words = inputValue
                        .toLowerCase()
                        .split(" ")
                        .filter(Boolean);

                      return options.filter((customer) =>
                        words.every(
                          (word) =>
                            customer.fname.toLowerCase().includes(word) ||
                            (customer.mobile && customer.mobile.includes(word))
                        )
                      );
                    }}
                    sx={{ background: "white" }}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        // Use changeHandler directly with simulated event
                        changeHandler({
                          target: {
                            name: "customer_id",
                            value: newValue.id,
                          },
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Firm Name"
                        name="customer_id"
                        onChange={changeHandler}
                        fullWidth
                      />
                    )}
                    renderOption={(props, option, { inputValue }) => (
                      <li {...props}>
                        <Box display="flex" flexDirection="column">
                          <Typography variant="body2">
                            {highlightMatch(option?.fname, inputValue)}
                          </Typography>
                          {option?.mobile && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {highlightMatch(option?.mobile, inputValue)}
                            </Typography>
                          )}
                        </Box>
                      </li>
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name="role"
                    label="Role e.g Lead, Assistant"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.role || ""}
                    onChange={changeHandler}
                    error={!!validationErrors.role}
                    helperText={validationErrors.role}
                    sx={{ width: "100%", backgroundColor: "white" }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    label="Order No."
                    select
                    fullWidth
                    name="sort_order"
                    error={!!validationErrors.sort_order}
                    helperText={validationErrors.sort_order}
                    size="small"
                    sx={{ width: "100%", backgroundColor: "white" }}
                    value={Number(formData.sort_order)}
                    onChange={changeHandler}
                  >
                    {orderOptions.map((num) => (
                      <MenuItem key={num} value={num}>
                        {num}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

              </Grid>

              {/* Buttons */}
              <Grid
                container
                alignItems="flex-end"
                justifyContent="flex-end"
                mt={2}
                spacing={1}
              >
                <Grid
                  container
                  item
                  xs={12}
                  md={isEdit ? 12 : 8}
                  justifyContent={"flex-start"}
                ></Grid>
                <Grid item xs={6} md={2}>
                  <Button
                    fullWidth
                    color="secondary"
                    onClick={clear}
                    variant="contained"
                    size="small"
                    title="Reset"
                    startIcon={<RotateLeftIcon />}
                  >
                    Reset
                  </Button>
                </Grid>
                <Grid item xs={6} md={2}>
                  <Button
                    fullWidth
                    onClick={handleSubmit}
                    variant="contained"
                    color={isEdit ? "success" : "primary"}
                    startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                    size="small"
                  >
                    {isEdit ? "Update" : "Save"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </motion.div>
        </Container>
      )}

      <Box display="flex" justifyContent="center" alignItems="center" mt="5">
        <Typography variant="h4">{titlee}</Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Sn.no</StyledTableCell>

              <StyledTableCell>Title</StyledTableCell>
              <StyledTableCell>Description</StyledTableCell>
              <StyledTableCell>video url</StyledTableCell>
              <StyledTableCell>Order No.</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loader ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : faqs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="body1">No Data Found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              faqs.map((faq, index) =>
                index % 2 === 0 ? (
                  <StyledEvenRow key={faq.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                      }}
                    >
                      {faq.title}
                    </TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                      }}
                    >
                      {faq.description}
                    </TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                      }}
                    >
                      {faq.video_url}
                    </TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                      }}
                    >
                      {faq.order_number}
                    </TableCell>
                    {/* <TableCell>
                      {faq.status === 1 || faq.status === "1" ? "✅" : "❌"}
                    </TableCell> */}

                    <TableCell>
                      <IconButton onClick={() => handleEdit(faq)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </StyledEvenRow>
                ) : (
                  <TableRow key={faq.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                      }}
                    >
                      {faq.title}
                    </TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                      }}
                    >
                      {faq.description}
                    </TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                      }}
                    >
                      {faq.video_url}
                    </TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                      }}
                    >
                      {faq.order_number}
                    </TableCell>
                    {/* <TableCell>
                      {faq.status === 1 || faq.status === "1" ? "✅" : "❌"}
                    </TableCell> */}

                    <TableCell>
                      <IconButton onClick={() => handleEdit(faq)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                )
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default AddInstructor;
